/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter } from 'react-router-dom';
import * as ReactDOMClient from 'react-dom/client';
import PropTypes from 'prop-types';
// IMPORT - STYLING
// IMPORT - COMPONENTS
import ModalApk from './ModalApk';
// IMPORT - ELEMENTS
import Modal from '../Elements/Modal';
import Tables from '../Elements/Tables';
import CopyToClipboard from '../Elements/CopyToClipboard';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class BundlesApks extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * * Main constructor of Component
   * */
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      meta: {},
      page: 1,
      limit: 50,
      columns: {},
      search: '',
      sortBy: 'id',
      direction: 'asc',
      loading: true,
      optionsLimits: {
        50: true,
        100: false,
        250: false,
      },
      optionsColumns: [
        'id',
        'name',
        'version',
        'location',
        'meta',
        'description',
        'last_modified',
        'etag',
        'key',
        'package_name',
        'version_code',
        'tags',
        'created_at',
        'updated_at',
      ],
      optionsColumnsDefault: [
        'version',
        'package_name',
      ],
      optionsColumnLabels: {
        version: 'Version',
        package_name: 'Package',
      },
      modals: {
        apk: false,
      },
      modalData: [],
      modalSubmitted: false,
      loadingModal: true,
    };

    this.get = this.get.bind(this);
    this.updateShowModal = this.updateShowModal.bind(this);
    this.updateLoadingModal = this.updateLoadingModal.bind(this);
    this.updateModalSubmitted = this.updateModalSubmitted.bind(this);
    this.updateColumns = this.updateColumns.bind(this);
    this.updateColumnsShowHide = this.updateColumnsShowHide.bind(this);
    this.updateLimits = this.updateLimits.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.setModalSubmitted = this.setModalSubmitted.bind(this);
    this.update = this.update.bind(this);
    this.requestPut = this.requestPut.bind(this);
    this.updateSortDirection = this.updateSortDirection.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.get();
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {boolean} submitted
   */
  setModalSubmitted(submitted) {
    this.setState({
      modalSubmitted: submitted,
    });
  }

  /**
  *
  */
  searchTimeout = null;

  /**
  * Handler before API request
  */
  get(params, callback, failback) {
    this.setState({
      data: [],
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
        order_by: `${this.state.sortBy}.${this.state.direction}`,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      Object.keys(this.state.columns).map((item) => {
        if (this.state.columns[item].search && this.state.columns[item].search.length > 0) {
          defaultPayload[item] = this.state.columns[item].search;
        }
        return item;
      });

      this.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.bundle && response.bundle.apks) {
            const columns = {};

            (this.state.optionsColumns).map((item) => {
              columns[item] = {
                label: (this.state.optionsColumnLabels[item])
                  ? this.state.optionsColumnLabels[item]
                  : null,
                search: (this.state.columns[item])
                  ? this.state.columns[item].search
                  : '',
              };

              if (this.state.columns[item] && this.state.columns[item].visible) {
                columns[item].visible = this.state.columns[item].visible;
              } else if (this.state.optionsColumnsDefault
                && this.state.optionsColumnsDefault.indexOf(item) === -1) {
                columns[item].visible = false;
              } else {
                columns[item].visible = true;
              }

              return item;
            });

            this.setState({
              data: response.bundle.apks,
              meta: {
                total: response.bundle.apks.length,
              },
              columns,
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          }
        },
      );
    });
  }

  /**
  * Main API request
  */
  request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.id}${query}`,
      'GET',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */
  update(payload, callback, failback) {
    this.setState({
      loading: true,
    }, () => {
      this.requestPut(
        payload,
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else {
            this.get();
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.get();
          }
        },
      );
    });
  }

  /**
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */
  requestPut(payload, callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.id}`,
      'put',
      JSON.stringify(payload),
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
  * @param {boolean} show
  */
  updateLoadingModal(show) {
    this.setState({
      loadingModal: show,
    });
  }

  /**
  * @param {string} modal
  */
  updateShowModal(modal, show) {
    const { modals } = this.state;
    modals[modal] = show;
    this.setState({
      modals,
    });
  }

  /**
  * @param {boolean} submitted
  */
  updateModalSubmitted(submitted) {
    this.setState({
      modalSubmitted: submitted,
    });
  }

  /**
  * @param {object} columns
  * @param {string} key
  */
  updateColumnsShowHide(columns, key, show) {
    // if reseting the search make an updated request
    if (columns[key].search.length > 0 && !show) {
      const newColumns = { ...columns };
      newColumns[key].search = '';
      this.setState({
        columns: newColumns,
      }, () => {
        this.get();
      });
    } else { // if no search was present just hide/show the field
      this.setState({
        columns,
      });
    }
  }

  /**
  * @param {object} columns
  */
  updateColumns(columns) {
    this.setState({
      columns,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
  }

  /**
  * @param {object} limits
  */
  updateLimits(limits) {
    this.setState({
      page: 1,
      limit: Object.keys(limits).filter((item) => (limits[item]))[0],
      optionsLimits: limits,
    }, () => {
      this.get();
    });
  }

  /**
  * @param {string} search
  */
  updateSearch(search) {
    this.setState({
      search,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 350);
    });
  }

  /**
  * @param {integer} page
  */
  updatePage(page) {
    this.setState({
      page,
    }, () => {
      this.get();
    });
  }

  /**
  * @param {Event} event
  * @param {object} data
  */
  static onClickRow(event) {
    event.preventDefault();
  }

  /**
  * @param {string} data
  */
  static onCopyToClipboard(data) {
    const container = document.getElementById('hidden');
    const root = ReactDOMClient.createRoot(container);

    root.render(
      <CopyToClipboard data={data} callback={() => root.render('')} />,
    );
  }

  /**
   * Show / hide modal windows
   * @param {boolean} type
  */
  handleShowModal(type, show) {
    const { modals } = this.state;
    modals[type] = show;
    this.setState({
      modals,
    });
  }

  /**
  * @param {string} key
  */
  updateSortDirection(key) {
    this.setState((prevState) => {
      let direction = (prevState.direction === 'asc') ? 'desc' : 'asc';
      direction = (prevState.sortBy !== key) ? 'asc' : direction;

      return {
        sortBy: key,
        direction,
      };
    }, () => {
      this.get();
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col col-12">
            <div className="content">
              <Tables
                uniqueKey="id"
                search={this.state.search}
                data={this.state.data}
                meta={this.state.meta}
                page={this.state.page}
                limit={this.state.limit}
                columns={this.state.columns}
                sortBy={this.state.sortBy}
                direction={this.state.direction}
                loading={this.state.loading}
                optionsShowSearch={false}
                optionsShowPagination={false}
                optionsShowResults
                optionsShowColumns={false}
                optionsShowLimit={false}
                optionsShowSearchColumn={false}
                optionsLimits={this.state.optionsLimits}
                optionsSelections={{
                  copy: {
                    label: 'Copy To Clipboard',
                    action: (data) => {
                      const ids = this.state.data.map((item) => ((data.indexOf(item.id) > -1)
                        ? item.id
                        : null)).filter((item) => item);
                      BundlesApks.onCopyToClipboard(ids);
                    },
                  },
                  remove: {
                    label: 'Remove',
                    action: (data) => {
                      const ids = this.state.data.map((item) => ((data.indexOf(item.id) > -1)
                        ? null
                        : item.id)).filter((item) => item);

                      this.update({
                        apk_ids: ids,
                      });
                    },
                  },
                }}
                optionsRows={{
                  comment: {
                    label: 'Remove',
                    action: (data) => {
                      const ids = this.state.data.map((item) => {
                        if (item.id !== data.id) {
                          return item.id;
                        }
                        return null;
                      }).filter((item) => item);

                      this.update({
                        apk_ids: ids,
                      });
                    },
                  },
                }}
                optionsCustomButtons={{
                  add: {
                    style: 'btn-primary btn-rounded float-right',
                    label: 'Add APK',
                    action: () => {
                      this.setState((prevState) => ({
                        modalData: { ...{ id: this.props.id }, ...{ apks: prevState.data } },
                      }), () => {
                        this.handleShowModal('apk', true);
                      });
                    },
                  },
                }}
                onUpdateSearch={this.updateSearch}
                onUpdatedColumns={this.updateColumns}
                onUpdateColumnsShowHide={this.updateColumnsShowHide}
                onUpdatedLimits={this.updateLimits}
                onUpdatePage={this.updatePage}
                onUpdateSortDirection={this.updateSortDirection}
                onClickRow={BundlesApks.onClickRow}
              />
            </div>
          </div>
        </div>

        {(this.state.modals.apk)
          ? (
            <Modal
              size="modal-lg"
              title="APK"
              loading={this.state.loadingModal}
              updateLoadingModal={this.updateLoadingModal}
              submitted={this.state.modalSubmitted}
              cancel={(event) => {
                this.handleShowModal('apk', false);
                event.preventDefault();
              }}
              buttonCloseLabel="Close"
              buttonCloseAction={(event) => {
                this.handleShowModal('apk', false);
                event.preventDefault();
              }}
              buttonSubmitAction={(event) => {
                const form = document.getElementById('modal-view-apk');
                form.getElementsByTagName('button')[0].click();
                event.preventDefault();
              }}
            >
              <ModalApk
                id="modal-view-apk"
                loading={this.state.loadingModal}
                data={this.state.modalData}
                updateLoadingModal={this.updateLoadingModal}
                submitted={this.state.modalSubmitted}
                handleSubmit={this.setModalSubmitted}
                handleSubmitSuccess={() => {
                  this.get();
                  const { modals } = this.state;
                  modals.apk = false;
                  this.setState({
                    modals,
                    modalSubmitted: false,
                  });
                }}
              />
            </Modal>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
BundlesApks.propTypes = {
  id: PropTypes.number,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(BundlesApks);
